import React from "react";
import { FaAlignJustify } from "react-icons/fa";
import { Button, Link } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "react-scroll-to-top";

const Nav = () => {
  const [state, setState] = React.useState(false);
  AOS.init({
    duration: 600,
  });
  return (
    <>
      <nav className="navbar">
        <div className="container">
          <div className="navbar__container">
            <ul className="navbar__left">
              <div className="navbar__left-logo" data-aos="fade-right">
                <img src="/images/logo.png" alt="logo" />
              </div>
            </ul>
            {!state ? (
              <ul className="navbar__right">
                <li data-aos="fade-left">
                  <Link to="services" spy={true} smooth={true}>
                    Services
                  </Link>
                </li>
                <li data-aos="fade-left">
                  <Link to="about" spy={true} smooth={true}>
                    About
                  </Link>
                </li>

                <li data-aos="fade-left">
                  <Link to="contact" spy={true} smooth={true}>
                    Contact
                  </Link>
                </li>
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="toggle" onClick={() => setState(!state)}>
          <FaAlignJustify />
        </div>
        <div style={{ marginTop: "150vh" }} />
        <ScrollToTop smooth />
      </nav>
    </>
  );
};

export default Nav;
